import { inject } from '@angular/core';
import { ResolveFn, ActivatedRouteSnapshot, Router } from '@angular/router';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { UserService } from '../services/user.service';
import { ResponseDTO } from '@app/shared/models/response.model';


export const userResolver: ResolveFn<ResponseDTO | null> = (
    route: ActivatedRouteSnapshot
) => {
    const userService = inject(UserService);
    const router = inject(Router)
    const userName = route.paramMap.get('userName');

    if (!userName) {
        return of(null);
    }

    return userService.getUser(userName).pipe(
        catchError((error) => {
            console.error('Błąd pobierania użytkownika:', error);
            router.navigate(['/users']);
            return of(null);
        })
    );
};
